import React, { useRef, useState } from "react";
import DropdownList from "../../../Patient/partial/DropdownList";
import Select from "react-dropdown-select";
import DatePicker from "react-datepicker";

const NewLeaveForm = ({ onSubmit, onCancel, types = [], statusList = [], escorts = [] }) => {
    const venue = useRef();
    const clothing_desc = useRef();
    const mental_state_assessment_detail = useRef();
    const contact_tel_number = useRef();
    const plan_action = useRef();
    const evaluateLeave = useRef();

    // Local state
    const [datetime_out, setDatetimeOut] = useState(new Date());
    const [datetime_back, setDatetimeBack] = useState(new Date().setHours(24));
    const [photoUpdated, setPhotoUpdated] = useState(false);
    const [beenAccessed, setBeenAccessed] = useState(false);
    const [typeState, setType] = useState(null);
    const [status, setStatus] = useState(null);
    const [authorized, setAuthorized] = useState(false);
    const [selectedEscorts, setEscorts] = useState([]);

    const options = escorts.map((item) => ({
        id: item.id,
        display: `${item.surname} ${item.first_name} (${item.email})`,
    }));
    return (
        <form
            method="POST"
            onSubmit={(e) => {
                e.preventDefault();
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                onSubmit({
                    type: typeState.id,
                    authorized,
                    datetime_out,
                    venue: venue.current.value,
                    photo_updated: photoUpdated,
                    clothing_desc: clothing_desc.current.value,
                    been_accessed: beenAccessed,
                    mental_state_assessment_detail: mental_state_assessment_detail.current.value,
                    return_datetime: datetime_back,
                    evaulate_leave: evaluateLeave.current.value,
                    contact_tel_number: contact_tel_number.current.value,
                    plan_action: plan_action.current.value,
                    status: status.name,
                    escorts: selectedEscorts.map((i) => i.id),
                });
            }}
        >
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Leave Status</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td colSpan="2">
                                <h5 className="text-primary">
                                    Please ensure that this Leave Form is attached to the correct Leave Authorization detailing the correct type Leave Escorted or Unescorted
                                </h5>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Status*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <DropdownList title="" items={statusList} value="id" displayText="name" id="status_id" onSelect={(item) => setStatus(item)} />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Has this Leave Authorization been read*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <div className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="auth" name="auth" onSelect={() => setAuthorized(true)} value="1" className="custom-control-input" />
                                    <label className="custom-control-label" htmlFor="auth">
                                        Yes
                                    </label>
                                </div>
                                <div className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="auth2" name="auth" onChange={() => setAuthorized(false)} value="0" className="custom-control-input" />
                                    <label className="custom-control-label" htmlFor="auth2">
                                        No
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Type of Leave*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <DropdownList id="type_id" title="" items={types} onSelect={(item) => setType(item)} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Going out on leave</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Date Out*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <DatePicker
                                    selected={datetime_out}
                                    onChange={(date) => setDatetimeOut(date)}
                                    className="form-control input-height"
                                    timeIntervals={15}
                                    showTimeSelect
                                    timeCaption="Time"
                                    dateFormat="MMM d, yyyy h:mm aa"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Number of escorts*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <Select
                                    options={options}
                                    multi={true}
                                    valueField="id"
                                    labelField="display"
                                    onChange={(values) => setEscorts(values)}
                                    searchable={true}
                                    color="#0066f5 "
                                    searchBy="display"
                                    addPlaceholder="+ Select Escort"
                                    clearable={true}
                                    separator={true}
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Venue*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <input type="text" ref={venue} className="form-control input-height" id="venue-id" required aria-describedby="venue-id" placeholder="enter venue" />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong> Is the patient's photo up to date?*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <div className="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="photoUpdated" name="photoUpdated" onChange={(e) => setPhotoUpdated(Boolean(e.target.value))} value="1" className="custom-control-input" />
                                    <label className="custom-control-label" htmlFor="photoUpdated">
                                        Yes
                                    </label>
                                </div>
                                <div className="custom-control custom-radio custom-control-inline">
                                    <input
                                        type="radio"
                                        id="customRadioInline2"
                                        name="photoUpdated"
                                        onChange={(e) => setPhotoUpdated(Boolean(e.target.value))}
                                        value="0"
                                        className="custom-control-input"
                                    />
                                    <label className="custom-control-label" htmlFor="customRadioInline2">
                                        No
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Clothing Description*</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <textarea
                                    name="clothing-id"
                                    id="clothing-id"
                                    ref={clothing_desc}
                                    className="form-control form-control-textarea"
                                    required
                                    rows="6"
                                    placeholder="enter clothing description"
                                ></textarea>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Has the patients presentation / mental state has been assessed prior to existing the ward?</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <div className="form-check">
                                    <input className="form-check-input" type="checkbox" value="1" onChange={(e) => setBeenAccessed(e.target.checked)} id="defaultCheck1" />
                                    <label className="form-check-label" htmlFor="defaultCheck1">
                                        Check if Yes
                                    </label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Mental state Assessment Details</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <textarea
                                    name="mental-assessment-id"
                                    id="mental-assessment-id"
                                    ref={mental_state_assessment_detail}
                                    className="form-control form-control-textarea"
                                    required
                                    rows="6"
                                    placeholder="enter mental state description"
                                ></textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Returning from leave</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td colSpan="2">
                                <strong>if patient requires a rub down, please complete a personal search form</strong>
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Date Back</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <DatePicker
                                    selected={datetime_back}
                                    onChange={(date) => setDatetimeBack(new Date(date))}
                                    className="form-control input-height"
                                    timeIntervals={15}
                                    showTimeSelect
                                    timeCaption="Time"
                                    dateFormat="MMM d, yyyy h:mm aa"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Evaluate Leave</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <textarea
                                    name="evaluate-leave-id"
                                    id="evaluate-leave-id"
                                    ref={evaluateLeave}
                                    className="form-control form-control-textarea"
                                    required
                                    rows="6"
                                    placeholder="enter leave evaluation"
                                ></textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Patient View</h5>
                </div>

                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td colSpan="2">
                                <strong>Did the leave period meet its purpose?</strong>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="2">
                                <textarea name="evaluate-purpose-id" id="evaluate-purpose-id" className="form-control form-control-textarea" required rows="6"></textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-3 bg-primary text-center">
                    <h5>Contingency Plan</h5>
                </div>
                <table className="table table-bordered">
                    <tbody>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Contact Telephone Number</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <input
                                    name="contact-phone-id"
                                    text="text"
                                    ref={contact_tel_number}
                                    id="contact-phone-id"
                                    className="form-control input-height"
                                    required
                                    placeholder="enter telephone number"
                                />
                            </td>
                        </tr>
                        <tr>
                            <td style={{ width: "40%" }}>
                                <strong>Agreed Plan and Actions</strong>
                            </td>
                            <td style={{ width: "60%" }}>
                                <textarea
                                    name="plans-actions-id"
                                    id="plans-actions-id"
                                    ref={plan_action}
                                    className="form-control form-control-textarea"
                                    required
                                    rows="6"
                                    placeholder="enter plan and actions"
                                ></textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="row">
                <div className="col-12 text-center m-t-20">
                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-primary">
                        Submit Leave <i className="material-icons">keyboard_arrow_down</i>
                    </button>
                    <button type="button" onClick={onCancel} className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle">
                        Cancel <i className="material-icons text-danger">close</i>
                    </button>
                </div>
            </div>
        </form>
    );
};
export default NewLeaveForm;
